import { LitElement, html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';

declare global {
    interface HTMLElementTagNameMap {
        'psw-sim-logo': PswSimLogo;
    }
}

@customElement('psw-sim-logo')
export class PswSimLogo extends LitElement {
    public render(): TemplateResult {
        return html`
            <svg width="323" height="36" viewBox="0 0 323 36" fill="none" 
                xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1816_16894)">
                    <path d="M8.07398 29.075H0L6.46696 6H23.0167L21.4421 11.4755H12.9987L11.9166
                        15.4024H20.3599L18.9343 20.4437H10.491L8.08046 29.075H8.07398Z" fill="white"/>
                    <path d="M26.7557 29.075H18.7725L23.5028 12.2142H31.4861L26.7557
                        29.075ZM31.9202 10.6072H23.9434L25.2394 6H33.2162L31.9202 10.6072Z" fill="white"/>
                    <path d="M47.4588 29.075H39.6311L40.1883 27.1893C38.6137 28.5177 37.0002
                        29.4768 34.4342 29.4768C31.8681 29.4768 30.1963 28.2391 30.1963 25.6082C30.1963
                        22.6988 31.3432 18.3702 33.041 15.3376C34.2786 13.0826 36.5077 11.9032 39.1321
                        11.9032C41.3871 11.9032 43.0589 12.8946 43.7069 14.1323L45.936 6H53.9193L47.4523
                        29.075H47.4588ZM41.4584 17.2297C40.7456 17.2297 40.0328 17.45 39.6311
                        18.435C39.0414 19.8606 38.5165 21.2473 38.5165 22.6404C38.5165 23.2884
                        38.9831 23.8457 39.7542 23.8457C40.3698 23.8457 40.778 23.6578 41.115
                        23.444L42.722 17.9036C42.4433 17.5019 41.9509 17.2232 41.4519 17.2232L41.4584
                        17.2297Z" fill="white"/>
                    <path d="M69.9894 21.7138H58.98C58.7662 22.608 58.5459 23.2301 58.5459
                        23.9429C58.5459 24.2863 58.6042 25.1482 59.7187 25.1482C60.8333 25.1482
                        61.3258 24.714 61.7923 23.0746H69.6201C68.6286 27.8697 62.9393 29.5092
                        59.4466 29.5092C54.7162 29.5092 51.0356 28.8288 51.0356 24.2799C51.0356
                        21.7721 52.3057 17.6315 53.971 15.4348C55.9798 12.8039 59.479 11.819
                        62.693 11.819C67.6437 11.819 70.8577 12.8363 70.8577 17.0483C70.8577
                        18.0721 70.4236 20.3271 69.9894 21.7203V21.7138ZM62.0062 16.0568C61.0147
                        16.0568 60.3343 16.7372 59.9002 18.435H63.179C63.2697 18.098 63.3929
                        17.5667 63.3929 17.2621C63.3929 16.3355 62.8356 16.0568 61.9997 16.0568H62.0062Z"
                        fill="white"/>
                    <path d="M78.0052 29.075H70.022L76.4889 6H84.4722L78.0052 29.075Z" fill="white"/>
                    <path d="M88.5546 29.075H80.5713L85.3016 12.2142H93.2849L88.5546
                        29.075ZM93.7191 10.6072H85.7358L87.0318 6H95.015L93.7191 10.6072Z" fill="white"/>
                    <path d="M108.066 12.2143L108.759 16.018H102.649L100.854 22.4201C100.698
                        22.9126 100.575 23.5347 100.575 23.9364C100.575 24.6816 100.886 24.9279
                        101.968 24.9279H103.672L102.5 29.075H95.3846C93.0324 29.075 92.1382
                        27.9281 92.1382 26.1979C92.1382 25.4851 92.2289 24.714 92.4816 23.8457L96.8102
                        8.47534H104.793L103.744 12.2207H108.072L108.066 12.2143Z" fill="white"/>
                    <path d="M118.835 12.2142L114.507 21.5583L114.63 12.2142H106.556L108.104
                        29.075C107.91 30.0599 107.579 30.6172 106.964 30.8958C106.283 31.2004
                        104.754 31.1421 104.216 31.1162H104.119L102.849 35.704H108.299C111.513
                        35.704 113.094 34.0905 115.381 30.5071L127.013 12.2272H118.848L118.835
                        12.2142Z" fill="white"/>
                </g>
                <path d="M232.348 15.352C232.924 15.352 233.473 15.4373 233.996 15.608C234.519
                    15.768 235.015 16.0187 235.484 16.36V17.944C234.929 17.4533 234.385 17.0907
                    233.852 16.856C233.319 16.6107 232.791 16.488 232.268 16.488C231.585 16.488
                    231.041 16.6693 230.636 17.032C230.231 17.3947 230.028 17.8853 230.028
                    18.504C230.028 19.0267 230.188 19.4533 230.508 19.784C230.839 20.104 231.457
                    20.3973 232.364 20.664C233.591 21.0267 234.455 21.4693 234.956 21.992C235.468
                    22.504 235.724 23.1707 235.724 23.992C235.724 24.9947 235.367 25.8 234.652
                    26.408C233.937 27.016 233.031 27.32 231.932 27.32C231.335 27.32 230.743
                    27.2293 230.156 27.048C229.58 26.8773 229.015 26.616 228.46 26.264V24.6C229.089
                    25.144 229.692 25.5493 230.268 25.816C230.844 26.072 231.404 26.2 231.948
                    26.2C232.652 26.2 233.217 26.008 233.644 25.624C234.071 25.24 234.284 24.7333
                    234.284 24.104C234.284 23.5813 234.103 23.1493 233.74 22.808C233.388 22.456
                    232.748 22.1413 231.82 21.864C230.657 21.5333 229.831 21.112 229.34 20.6C228.849
                    20.0773 228.604 19.3893 228.604 18.536C228.604 17.576 228.951 16.808 229.644
                    16.232C230.348 15.6453 231.249 15.352 232.348 15.352ZM239.169 27H237.745V15.672H239.169V27ZM247.194
                    27L243.145 17.448H243.065L243.113 27H241.737V15.672H243.833L247.657 24.872H247.721L251.514
                    15.672H253.594V27H252.218L252.234 17.448H252.17L248.106 27H247.194ZM265.175
                    15.672V22.632C265.175 24.1253 264.775 25.2827 263.975 26.104C263.186 26.9147
                    262.05 27.32 260.567 27.32C259.106 27.32 257.98 26.9147 257.191 26.104C256.412
                    25.2827 256.023 24.1253 256.023 22.632V15.672H257.399V22.584C257.399 23.704
                    257.671 24.5787 258.215 25.208C258.77 25.8373 259.564 26.152 260.599 26.152C261.623
                    26.152 262.407 25.8373 262.951 25.208C263.506 24.5787 263.783 23.704 263.783
                    22.584V15.672H265.175ZM274.062 27H267.598V15.672H268.974V25.832H274.062V27ZM281.898
                    23.064L279.578 17.16L277.162 23.064H281.898ZM284.97 27H283.45L282.362
                    24.216H276.698L275.562 27H274.09L278.954 15.672H280.234L284.97 27ZM292.333
                    16.856H288.749V27H287.341V16.856H283.757V15.672H292.333V16.856ZM295.077
                    27H293.653V15.672H295.077V27ZM303.007 27.32C301.279 27.32 299.855 26.76
                    298.735 25.64C297.625 24.52 297.071 23.0853 297.071 21.336C297.071 19.5867
                    297.625 18.152 298.735 17.032C299.855 15.912 301.279 15.352 303.007 15.352C304.724
                    15.352 306.137 15.9173 307.247 17.048C308.367 18.1787 308.927 19.624 308.927
                    21.384C308.927 23.1227 308.372 24.5467 307.263 25.656C306.153 26.7653 304.735
                    27.32 303.007 27.32ZM303.007 16.568C301.716 16.568 300.649 17.0213 299.807
                    17.928C298.964 18.8347 298.543 19.9707 298.543 21.336C298.543 22.7013 298.964
                    23.8427 299.807 24.76C300.649 25.6667 301.716 26.12 303.007 26.12C304.297
                    26.12 305.364 25.672 306.207 24.776C307.049 23.8693 307.471 22.7387 307.471
                    21.384C307.471 20.0187 307.044 18.8773 306.191 17.96C305.348 17.032 304.287
                    16.568 303.007 16.568ZM312.311 27H310.935V15.672H312.615L318.919 25.192H318.967L318.903
                    15.672H320.295V27H318.567L312.311 17.592H312.263L312.311 27Z" fill="white"/>
                <path d="M216.698 7.37805C218.898 7.37805 220.692 9.17566 220.692 11.3927C220.692
                    13.6097 218.898 15.4073 216.698 15.4073C214.486 15.4073 212.692 13.5977
                    212.692 11.3927C212.692 9.1757 214.498 7.37812 216.698 7.37805ZM216.698
                    8.0968C214.88 8.09684 213.41 9.57036 213.41 11.3917C213.41 13.2133 214.88
                    14.6876 216.698 14.6876C218.515 14.6876 219.986 13.2133 219.986 11.3917C219.986
                    9.57034 218.515 8.0968 216.698 8.0968Z" fill="white"/>
                <path d="M216.697 9.51056C217.551 9.51068 217.953 9.90291 217.953 10.6131C217.953
                    11.2493 217.582 11.5572 217.099 11.6209L218.025 13.1688H217.335L216.45
                    11.6736H215.977V13.1688H215.358V9.51056H216.697ZM216.46 10.0858H215.986V11.1141H216.46C216.861
                    11.1141 217.305 11.0822 217.305 10.5945C217.305 10.0961 216.862 10.0751
                    216.46 10.0858Z" fill="white"/>
                <path d="M154.723 20.0461H149.646V29.3999H147V7.61538H154.477C158.2 7.61538
                    161.861 9.0923 161.861 13.7076C161.861 17.923 158.631 20.0461 154.723
                    20.0461ZM154.569 9.89229H149.646V17.7692H154.661C156.877 17.7692 159.031
                    16.5384 159.031 13.7384C159.031 10.9384 156.754 9.89229 154.569 9.89229Z"
                    fill="white"/>
                <path d="M178.575 8.93845V11.9846C176.544 10.2 174.513 9.1846 172.39 9.1846C169.836
                    9.1846 168.083 10.6307 168.083 13.0615C168.083 15.5846 169.959 16.4461
                    172.575 17.2153C176.606 18.4153 179.036 20.0153 179.036 23.6153C179.036
                    27.7999 175.559 30.0152 171.744 30.0152C169.129 30.0152 166.913 29.1537
                    165.067 27.9845V24.7845C167.529 26.8768 169.713 27.8614 171.775 27.8614C174.483
                    27.8614 176.267 26.2614 176.267 23.8307C176.267 21.2461 174.083 20.2922
                    171.529 19.523C167.559 18.3845 165.344 16.7538 165.344 13.123C165.344 9.21537
                    168.575 7 172.544 7C175.006 7 176.975 7.8 178.575 8.93845Z" fill="white"/>
                <path d="M195.967 11.4615L190.521 29.3999H187.874L181.351 7.61538H184.244L189.259
                    25.4614H189.351L194.613 7.61538H197.444L202.828 25.4614H202.921L207.936
                    7.61538H210.705L204.151 29.3999H201.536L196.028 11.4615H195.967Z" fill="white"/>
                <defs>
                    <clipPath id="clip0_1816_16894">
                        <rect width="127" height="29.704" fill="white" transform="translate(0 6)"/>
                    </clipPath>
                </defs>
            </svg>
        `;
    }
    // this removes the shadow dom
    public createRenderRoot() {
        return this;
    }
}
